import React from 'react';
import SubServices from '../common/sub-services';
const CakePhpServies = () => {
    return (
        <div className="section-py bg-grey dark:bg-black">
            <div className="container lg:container mx-auto">
                <div className="row grid lg:grid-cols-12">
                    <div className="text-center lg:col-span-8 lg:col-start-3 pb-50">
                        <p
                            className="text-primary mb-0 fs-lg fw-700"
                            data-aos="fade-up"
                            data-aos-duration="700"
                            data-aos-delay="200"
                        >
                            We Provide
                        </p>
                        <h2 data-aos="fade-up" data-aos-duration="700" data-aos-delay="100">
                            Android Application Development Services
                        </h2>
                    </div>
                </div>
                <div className="row grid xl:grid-cols-3 lg:grid-cols-2 md:grid-cols-2">
                    <SubServices
                        path={'/img/technology/ic-cakephp-application-development.svg'}
                        height={64}
                        width={64}
                        alt="CakePHP"
                        title="CakePHP"
                        serviceName="CakePHP Application Development"
                        serviceDescription="We build websites that focuses more on your business requirements. Contact us now to develop a solution that suits your requirements."
                    />
                    <SubServices
                        path={'/img/technology/ic-development.svg'}
                        height={64}
                        width={64}
                        alt="CakePHP"
                        title="CakePHP"
                        serviceName="CakePHP Website Development"
                        serviceDescription="Our services are not just confined with web development, instead we build static websites that are custom, secure as well scalable. We build websites that are interactive, rich-featured and enhances productivity."
                    />
                    <SubServices
                        path={'/img/technology/ic-ecommerce-development.svg'}
                        height={64}
                        width={64}
                        alt="ecommerce"
                        title="ecommerce"
                        serviceName="CakePHP E-commerce Development"
                        serviceDescription="If you're looking forward to build customized e-commerce store with CakePHP, Moweb is the perfect solution partner for you. We build online stores that are ideal for your business."
                    />
                    <SubServices
                        path={'/img/technology/ic-cakephp-cms-development.svg'}
                        height={64}
                        width={64}
                        alt="CMS Development"
                        title="CMS Development"
                        serviceName="CakePHP CMS Development"
                        serviceDescription="Get the structured as well interactive CMS based solution only with Moweb. We ensure you to build rich-featured and intact CMS for your business."
                    />
                    <SubServices
                        path={'/img/technology/ic-plugin-development.svg'}
                        height={64}
                        width={64}
                        alt="support"
                        title="support"
                        serviceName="CakePHP Plugin Development"
                        serviceDescription="Extend your website's features and functionalities with Moweb's developed CakePHP website plugin."
                    />
                    <SubServices
                        path={'/img/technology/ic-cakephp-customization.svg'}
                        height={64}
                        width={64}
                        alt="Customization"
                        title="Customization"
                        serviceName="CakePHP Customization"
                        serviceDescription="Let your business give an edge over your competitors with our high-end and customized CakePHP solutions."
                    />
                </div>
            </div>
        </div>
    );
};

export default CakePhpServies;
